var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreTrainingModeUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.425 6.413c-.21.116-.38.282-.497.477-.114.189-.178.406-.178.632v8.957c0 .225.064.442.178.631.117.195.288.36.498.477l8.09 4.485c.432.238.965.238 1.398 0l8.09-4.485c.209-.116.38-.282.497-.477.114-.189.177-.406.178-.632V7.52c0-.225-.064-.442-.178-.631a1.337 1.337 0 00-.498-.477l-8.09-4.485c-.619-.341-1.56.092-9.488 4.485z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.429 17.769a.786.786 0 001.571 0v-5.721l-5.88-3.1a.786.786 0 00-.733 1.39l5.042 2.658v4.773z",
    stroke: "none",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.769a.786.786 0 01-1.571 0v-5.721l5.88-3.1a.786.786 0 01.733 1.39L13 12.996v4.773z",
    stroke: "none",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreTrainingModeUtility);
export default __webpack_public_path__ + "static/media/PreTrainingModeUtility.85e22e4a.svg";
export { ForwardRef as ReactComponent };